import gql from 'graphql-tag'

export const fetchPendingOrdersQuery = gql`
  query (
    $sap_id: [String!]
    $date_from: String
    $date_to: String
    $deliver_to: String
    $bill_to: String
    $currentPage: Int
    $shipto_name: String
    $pageSize: Int = 10
    $customer_order_number: String
  ) {
    getPreOrder(
      deliver_to: $deliver_to
      shipto_name: $shipto_name
      bill_to: $bill_to
      date_from: $date_from
      date_to: $date_to
      sap_id: $sap_id
      pageSize: $pageSize
      currentPage: $currentPage
      sort: "DESC"
      customer_order_number: $customer_order_number
    ) {
      page_info {
        total_unique_items
        total_items
        total_pages
      }
      items {
        id
        date
        total
        total_qty
        deliver_to
        shipto_name
        bill_to
        pre_order
        is_active
        cart_id
        outlet_id
        customer_order_number
        total_with_tax
        total_layer
        total_pallet
        total_hecto
      }
    }
  }
`

export const fetchPendingOrdersDetailQuery = gql`
  query ($cart_id: String!) {
    getPreOrderDetails(cart_id: $cart_id, pre_order: true) {
      email
      transporttype
      ship_to_id
      delivery_date
      id
      grand_total_your_price_tax
      grand_total_your_price
      pre_order
      sap_order_type
      billing_address {
        city
        country {
          code
          label
        }
        firstname
        lastname
        postcode
        region {
          code
          label
        }
        street
        telephone
      }
      shipping_addresses {
        firstname
        lastname
        street
        city
        region {
          code
          label
        }
        country {
          code
          label
        }
        telephone
        available_shipping_methods {
          amount {
            currency
            value
          }
          available
          carrier_code
          carrier_title
          error_message
          method_code
          method_title
          price_excl_tax {
            value
            currency
          }
          price_incl_tax {
            value
            currency
          }
        }
        selected_shipping_method {
          amount {
            value
            currency
          }
          carrier_code
          carrier_title
          method_code
          method_title
        }
      }
      items {
        ... on CartItemInterface {
          product {
            number_of_products_on_layer
            number_of_items_on_pallet
            number_of_layers_per_pallet
            name
            catalog_product_name
            sku
            volume
            small_image {
              url
            }
          }
          quantity
          hectolitres_fe
          prices {
            your_price
            your_price_tax
            total_your_price_tax
          }
          errors {
            code
            message
          }
        }
        ... on SimpleCartItem {
          quantity_total
          number_of_packages
          number_of_layer
          number_of_layer_total
          number_of_pallet
        }
      }
      selected_payment_method {
        code
        title
      }
      prices {
        grand_total {
          value
          currency
        }
      }
    }
  }
`
